import { QuestionIcon } from '@phosphor-icons/react';
import classNames from 'classnames';
import { FunctionComponent, ReactNode } from 'react';
import { Form } from 'react-bootstrap';

import { Tooltip } from 'waldur-ui';

import { FormField } from './types';

interface AwesomeCheckboxFieldProps extends FormField {
  className?: string;
  checked?: boolean;
  tooltip?: ReactNode;
  tooltipEnd?: boolean;
  size?: 'sm';
  help_text?: ReactNode;
  disabled?: boolean;
  alignMiddle?: boolean;
  onChange?(v: boolean): void;
}

export const AwesomeCheckboxField: FunctionComponent<
  AwesomeCheckboxFieldProps
> = ({
  input,
  label,
  className,
  tooltip,
  tooltipEnd,
  help_text,
  alignMiddle,
  onChange,
  ...props
}) => {
  const id = props.id || 'check-' + input.name;
  return (
    <div
      className={classNames(
        'form-check form-switch form-check-custom form-check-solid',
        props.size === 'sm' && 'form-switch-sm',
        alignMiddle && 'align-items-center',
        className,
      )}
    >
      <Form.Check
        id={id}
        checked={input.checked ?? input.value}
        onChange={(e: React.ChangeEvent<any>) => {
          input.onChange(e.target.checked);
          if (onChange) onChange(e.target.checked);
        }}
        data-testid={props['data-testid']}
        disabled={props.readOnly || props.disabled}
      />

      {(tooltip || label || help_text) && (
        <Form.Check.Label htmlFor={id}>
          {tooltip && !tooltipEnd && (
            <>
              <Tooltip label={tooltip}>
                <QuestionIcon weight="bold" size={20} className="text-muted" />
              </Tooltip>{' '}
            </>
          )}
          {label}
          {/* mb-0: the paragraph's own bottom margin lands inside the
              control's box, so the gap below a toggle with help text came out
              13px larger than the one above it. */}
          {help_text && <p className="text-muted mb-0">{help_text}</p>}
        </Form.Check.Label>
      )}
      {tooltip && tooltipEnd && (
        <Tooltip label={tooltip}>
          <QuestionIcon
            weight="bold"
            size={20}
            className="align-self-center ms-auto text-muted"
          />
        </Tooltip>
      )}
    </div>
  );
};
